import { AutoComplete, Button, Form, Input, Modal, Spin } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { EditOutlined } from "@ant-design/icons";
import TopHeading from "./TopHeading";
import Empty from "../common/Empty";
import AddZone from "./AddZone";
import { debounce } from "lodash";

const ZoneList = () => {
  const [status, setStatus] = useState("");
  const [limit, setLimit] = useState(16);
  const [key, setKey] = useState("");

  const [zoneData, setZoneData] = useState({
    loading: false,
    data: null,
  });

  const [zoneOptions, setZoneOptions] = useState({
    loading: false,
    list: [],
  });

  const [zoneForEdit, setZoneForEdit] = useState(undefined);
  const [visible, setVisible] = useState(undefined);

  const [form] = Form.useForm();
  const loc = useLocation();

  const reseAllFieldData = () => {
    setStatus("");
    form.resetFields();
  };

  const getZone = useCallback(async () => {
    setZoneData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    axios
      .get(`${encodedUri}/zone/all` + (key ? `?name=${key}` : ``), {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      })
      .then((res) => {
        setZoneData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setZoneData({ loading: false, data: [] });
        console.error("Zone: Error", err);
      });
  }, [key]);
  //

  const getzoneOptions = useCallback(async (key) => {
    setZoneOptions({ loading: true, list: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    return axios
      .get(`${encodedUri}/zone/all` + (key ? `?name=${key}` : ``), {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
        },
      })
      .then((res) => {
        setZoneOptions({
          loading: false,
          list: res.data?.zones?.map((zone) => ({
            label: zone.name,
            value: zone.name,
          })),
        });
      })
      .catch((err) => {
        setZoneOptions({ loading: false, list: [] });
        console.error("Zones: Error", err);
      });
  }, []);

  const fetchRef = useRef(0);
  const debouncezoneOptionsFetcher = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      getzoneOptions(value);
    };

    return debounce(loadOptions, 800);
  }, [getzoneOptions]);

  useEffect(() => {
    if (visible) {
      setZoneForEdit(undefined);
    }
  }, [zoneForEdit, visible]);

  useEffect(() => {
    setZoneForEdit(undefined);
  }, [visible]);

  useEffect(() => {
    getZone();
    getzoneOptions("");
  }, [getZone, getzoneOptions]);

  const onClose = () => {
    setZoneForEdit(null);
    getZone();
  };

  return (
    <React.Fragment>
      <TopHeading {...zoneData?.data?.totalElements} refetch={getZone} />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="search">
            <AutoComplete
              style={{ width: 250 }}
              onSearch={debouncezoneOptionsFetcher}
              onSelect={(val) => setKey(val.toString())}
              options={zoneOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                zoneOptions?.loading ? <Spin size="small" /> : null
              }
            >
              <Input.Search
                placeholder="Search by Name"
                onSearch={(val) => setKey(val)}
                enterButton
                loading={zoneOptions.loading}
              />
            </AutoComplete>
          </Form.Item>
        </Form>

        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Zone</span>
                  </div>

                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {zoneData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {zoneData?.data?.zones?.length ? (
                    zoneData?.data?.zones?.map((zone: any, index: any) => (
                      <React.Fragment key={index}>
                        <div className="single-product-wrapper">
                          <div className="single-product">
                            <span className="name">{zone?.name}</span>
                          </div>
                          <div className="single-product">
                            <button
                              className="btn btn-sm btn-warning mx-1"
                              onClick={() => setZoneForEdit(zone)}
                            >
                              <EditOutlined />
                            </button>
                          </div>
                        </div>
                      </React.Fragment>
                    ))
                  ) : (
                    <Empty data="Zones" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Modal
            title="Add Zone"
            visible={zoneForEdit}
            onCancel={onClose}
            okText={`Submit`}
            footer={false}
          >
            <AddZone visibleData={zoneForEdit} onCloseMethod={onClose} />
          </Modal>

          <PaginationTwo
            {...zoneData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ZoneList;
